import {
  Pagination as CXPagination,
  PaginationItem as CXPaginationItem
} from '@sanlamcx/react-ui-next-pagination';

type PaginationItem = typeof CXPaginationItem;
export const Pagination = CXPagination;
export const PaginationItem: PaginationItem = CXPaginationItem;
